export const ON_ADD_NEW_WHITEBOARD_CLICK = "ON_ADD_NEW_WHITEBOARD_CLICK";
export const ON_REMOVE_WHITEBOARD_CLICK = "ON_REMOVE_WHITEBOARD_CLICK";



// WEBPACK FOOTER //
// ./src/store/analytics/chart-footer/actions.js